import { actionGenerator } from "utils";

const PREFIX = "GAME";

export const CREATE_TURN = actionGenerator.genActionTypes(
  `${PREFIX}_CREATE_TURN`
);
export const EXCHANGE_CODE = actionGenerator.genActionTypes(
  `${PREFIX}_EXCHANGE_CODE`
);
export const SPIN = actionGenerator.genActionTypes(`${PREFIX}_SPIN`);

export const TOPUP = actionGenerator.genActionTypes(`${PREFIX}_TOPUP`);
